const en = require('./locales/en.json');
const ru = require('./locales/ru.json');

module.exports = {
	en,
	ru
};
